import api from '@/services/api'

export async function simplifyQuestion() {
  const { data } = await api.patch('/fluency-test/simplify')
  return data
}
